//#region IMPORT
import React from 'react';
/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { getColumnDefs1 } from './WOR_BASIC_01_ColumnDefs';
/** Icons Import */

//#endregion
function WOR_BASIC_01(props) {
  //#region 변수
  const columnDefs1 = getColumnDefs1(props);
  //#endregion

  return (
    <React.Fragment>
      <BusinessGridCommon
        getRowId={(params) => {
          return params.data.no;
        }}
        deleteYn1={'N'}
        addYn1={'N'}
        enableRangeSelection
        enableFillHandle
        gridRef={props.gridRef1}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        stopEditingWhenCellsLoseFocus={false}
        deleteClick1={(e) => {
          if (!props.validateSelection()) return;

          const newRowExists = props.selectedRowData1.some(
            (row) => row.newYn === 'Y'
          );

          if (!newRowExists) {
            props.MarkedForDeletion1(props.selectedRowData1);
          } else {
            props.NewYnErrorMsg();
          }
        }}
        refreshClick1={(e) => {
          if (!props.validateSelection()) return;

          props.SearchLogic1();
        }}
        fileDownloadYn1="Y"
        fileDownloadClick1={() => {
          if (!props.validateSelection()) return;
          props.ExcelDownload1();
        }}
        setSelectedRowData={props.setSelectedRowData1}
        setChangedRowData={props.setChangedRowData1}
        onCellValueChanged={(e) => {
          const key = e.data.no;
          const field = e.column?.getColDef?.()?.field ?? e.colDef?.field;
          const newVal =
            e.newValue !== undefined
              ? e.newValue
              : field
                ? e.data?.[field]
                : undefined;
          props.setChangedRowData1?.((prev) => {
            const filtered = prev.filter((row) => row.no !== key);
            const updated = { ...e.data, editYn: 'Y' };
            if (field != null && newVal !== undefined) updated[field] = newVal;
            return [...filtered, updated];
          });
          props.setRowData1?.((prev) =>
            (prev || []).map((row) => {
              if (row.no !== key) return row;
              const merged = { ...row, ...e.data };
              if (field != null && newVal !== undefined) merged[field] = newVal;
              return merged;
            })
          );
        }}
        onCellEditingStopped={(e) => {
          const field = e.column?.getColDef?.()?.field ?? e.colDef?.field;
          const isHalfYearCol =
            typeof field === 'string' &&
            (field.endsWith('FirstHalf') || field.endsWith('SecondHalf'));
          if (!isHalfYearCol || !e.data?.no) return;
          const key = e.data.no;
          const updated = { ...e.data, editYn: 'Y' };
          props.setChangedRowData1?.((prev) => {
            const filtered = prev.filter((row) => row.no !== key);
            return [...filtered, updated];
          });
          props.setRowData1?.((prev) =>
            (prev || []).map((row) =>
              row.no !== key ? row : { ...row, ...updated }
            )
          );
        }}
        onCellClicked={(e) => {
          const gridApi = props.gridRef1.current.api;
          // 셀 에디터가 열린 상태에서 콤보 등 클릭 시 다른 셀로 튕기지 않도록 편집 중이면 스킵
          const editingCells = gridApi.getEditingCells?.() ?? [];
          if (editingCells.length > 0) return;

          const clickedRowIndex = e.rowIndex;
          const colKey = e.column?.getColId?.() ?? e.colDef?.field;

          const isCheckboxClick = e.event?.target?.type === 'checkbox';

          if (!isCheckboxClick) {
            gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
            if (colKey) {
              gridApi.setFocusedCell(clickedRowIndex, colKey);
            } else {
              gridApi.setFocusedCell(clickedRowIndex, 'gongJongNm');
            }

            const copied = JSON.parse(JSON.stringify(e.data));
            props.handleRowSelection1(copied, clickedRowIndex);

            gridApi
              .getDisplayedRowAtIndex(clickedRowIndex)
              ?.setSelected(true, false);
          }
        }}
        onSelectionChanged={() => {
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);
          props.selectedRowNosRef1.current = new Set(
            selectedData.map((r) => r.no)
          );
          props.setSelectedRowData1(selectedData);
        }}
      />
    </React.Fragment>
  );
}

export default WOR_BASIC_01;
